export const PROFESSIONAL_GET = '@PROFESSIONAL_GET'
export const PROFESSIONAL_GET_SUCCESS = '@PROFESSIONAL_GET_SUCCESS'
export const PROFESSIONAL_GET_FAILURE = '@PROFESSIONAL_GET_FAILURE'

export default {
  PROFESSIONAL_GET,
  PROFESSIONAL_GET_SUCCESS,
  PROFESSIONAL_GET_FAILURE
}
